export default "__VITE_ASSET__3e814e41__"